<script>
    import { createEventDispatcher } from 'svelte';

    import IconButton from "../../../inputs/IconButton/v1/IconButton.svelte";
    import FileSelect from "../../../inputs/FileSelect/v1/FileSelect.svelte";
    import TextField from "../../../inputs/TextField/v1/TextField.svelte";

    import { guidV4 } from "@itslearning/atlas/generate/guid";

    const dispatch = createEventDispatcher();

    /** @type {Object} */
    export let i18n = {
        label: "__Image__",
        description: "__Image description__",
        add: "__Add image__",
        change: "__Change image__",
        delete: "__Remove image__",
        progress: "__Image is uploading__",
        imageDescriptionTitle : "__Image description__",
        imageDescriptionHint: "__Image description hint__"
    };

    /** @type {String} */
    export let id = guidV4();

    /** @type {String} */
    export let url = undefined;

    /** @type {Boolean} */
    export let inProgress = false;

    /** @type {Boolean} */
    export let showLabel = true;

    /** @type {String} */
    export let errorMessage = undefined;

    /** @type {"image" | "avatar"} */
    export let previewType = "image";

    /** @type {string} */
    export let cssPreviewClass = "prom-select-image__preview";

    /** @type {string} */
    export let allowedExtensions = ".jpg,.jpeg,.png";

    /** @type {Boolean}*/
    export let disabled = false;

    /** @type {Boolean}*/
    export let showImageDescriptionField = false;

    /** @type {string} */
    export let imageDescription = "";

    /** @type {number} */
    export let imageDescriptionMaxLength = 1024;

    $: descriptionId = `description_${id}`;
    $: inputDescriptionId = `inputImageDescriptionId_${id}`;

    $: disabledControls = inProgress || disabled;

    let fileInput;

    function changeImage() {
        fileInput.click();
    }

    function pictureFilePicked() {
        const file = fileInput.files[0];

        dispatch('change', file);
    }

    function removeImage() {
        dispatch('remove');
    }

    function addLocalFile(file) {
        dispatch('change', file);
    }
</script>

<div class="prom-select-image">
    {#if showLabel}
        <label class="prom-select-image" for={id}>{i18n.label}</label>
    {/if}

    {#if i18n.description}
        <div id={descriptionId} class="prom-select-image__description">{i18n.description}</div>
    {/if}

    <input bind:this={fileInput}
        {id}
        type="file"
        accept={allowedExtensions}
        multiple={false}
        hidden
        disabled="{disabled}"
        on:change={pictureFilePicked}>

    {#if inProgress}
        <div class="prom-select-image__progress"></div>
    {:else if url}
        <img
            class={previewType === "avatar" ? "prom-select-image__profile-image" : cssPreviewClass}
            src={url}
            alt={imageDescription}
        >
    {:else}
        <FileSelect
            multiple={false}
            i18n={{ addFile: i18n.add }}
            accept={allowedExtensions}
            on:localFilesPicked={(event) => addLocalFile(event.detail.files[0])}
        />
    {/if}

    {#if !disabledControls && url}
        <div class="prom-select-image__toolbar">
            <IconButton
                type="plain"
                htmlType="button"
                iconClass="prom-select-image__change"
                text={i18n.change}
                on:click={changeImage} />
            <IconButton
                type="plain"
                htmlType="button"
                iconClass="prom-select-image__delete"
                text={i18n.delete}
                on:click={removeImage} />
        </div>
    {/if}

    <div aria-live="polite" class="prom-select-image__error">
        {#if inProgress}
            <div class="screen-reader">{i18n.progress}</div>
        {:else if errorMessage}
            <div class="prom-select-image__error-message">{errorMessage}</div>
        {/if}
    </div>

    {#if showImageDescriptionField && !inProgress && url}
        <div class="prom-select-image__input-container">
            <TextField
                id={inputDescriptionId}
                label={i18n.imageDescriptionTitle }
                type="area"
                maxlength="{imageDescriptionMaxLength}"
                hint={i18n.imageDescriptionHint}
                placeholder=""
                bind:value={imageDescription}
            />
        </div>
    {/if}
</div>
